// Accordion
class HeliosAccordion extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.js__accordion-button');
    this.content = this.querySelector('.js__accordion-content');

    if (!this.button || !this.content) return;

    this.button.setAttribute('aria-expanded', 'false');
    this.content.classList.remove('is-open');

    this.button.addEventListener('click', this.toggle);
    this.addEventListener('keydown', this.onKeyDown);

    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.removeEventListener('keydown', this.onKeyDown);
    this.content.classList.remove('is-open');
    document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick = (event) => {
    if (!this.contains(event.target)) {
        this.close();
    }
  };

  toggle = () => {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';

    this.button.setAttribute('aria-expanded', String(!isOpen));
    this.content.classList.toggle('is-open');
  };

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.content.classList.remove('is-open');
  }

  onKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };
}

if (!customElements.get('helios-accordion')) {
  customElements.define('helios-accordion', HeliosAccordion);
}
